<template>
  <div>
    <section class="h-100">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-md-6">
            <div class="card-wrapper" style="margin-top: 100px;">
              <div class="card fat">
                <div class="card-body">
                  <h4 class="card-title text-center text-muted">Bem Vindo!</h4>

                  <!--Name fields altered for new migrate-->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <text-input v-model="form.company_name.value" placeholder="Minha Empresa Ltda."
                          :name="'company_name'" :form="form" :alias="form.company_name.alias"></text-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <text-input v-model="form.user_name.value" placeholder="José dos Santos" :name="'user_name'"
                          :form="form" :alias="form.user_name.alias"></text-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <text-input v-model="form.email.value" placeholder="exemplo@exemplo.com" :name="'email'"
                          :form="form" :alias="form.email.alias"></text-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <password-input v-model="form.password.value" :name="'password'" :form="form"
                        :alias="form.password.alias"></password-input>
                    </div>

                    <div class="col-md-6">
                      <password-input v-model="form.password_confirmation.value" :name="'password_confirmation'"
                        :form="form" :alias="form.password_confirmation.alias"></password-input>
                    </div>
                  </div>

                  <br />
                  <error-handler :error="error" />
                  <b-alert :show="alertData.isVisible" fade variant="danger" @dismissed="alertData.isVisible = false"
                    dismissible>{{ alertData.message }}</b-alert>
                  <div>
                    <div class="form-group">
                      <button class="btn btn-primary btn-block" @click="submit">Criar conta agora!</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Form from "./../mixins/Form.js";

export default {
  data() {
    return {
      form: new Form({
        company_name: {
          alias: "Razão Social",
          validate: { required: true }
        },

        user_name: {
          alias: "Seu Nome",
          validate: { required: true }
        },

        email: {
          alias: "Email",
          validate: { required: true }
        },

        password: {
          validate: { required: "" },
          alias: "Crie uma senha"
        },

        password_confirmation: {
          validate: { required: "" },
          alias: "Confirme sua senha"
        }
      }),

      error: null,

      alertData: {
        isVisible: false,
        message: null
      }
    };
  },

  mounted() {
    this.redirect()
  },

  methods: {

    // submits form
    submit() {
      this.resetErrors()
      if (this.form.isValid()) {
        this.registerNewUserRequest()
      } else {
        this.setFormError()
      }
    },

    // make a request
    registerNewUserRequest() {
      this.$store.commit('showLoading')
      axios
        .post("registerNewUser", this.form.getValues())
        .then(response => {
          this.$store.commit('hideLoading')
          this.redirect()
        })
        .catch(error => {
          this.$store.commit('hideLoading')
          this.error = error;
        });
    },

    // // redirect in case of success
    // redirect() {
    //   this.$router.push("/login");
    // },

    redirect() {
      window.location.href = "https://sistema.apexcomercio.app/criar-conta?apexerp";
    },
    // set erros from form
    setFormError() {
      this.alertData.message = this.form.getFirstErrorMsg();
      this.alertData.isVisible = true;
    },

    // reset errors
    resetErrors() {
      this.error = null
      this.alertData.isVisible = false;
    },
  }
};
</script>
